import { getUrlOrigin } from '../helpers/getUrlOrigin';

export const createUrl = (pathname: string | undefined): URL => {
  return new URL(pathname || '', getUrlOrigin());
};

export default createUrl;
